import React from "react";
import CustomButton, {DangerButton} from "../../../../components/CustomButton";

export default function BrandLoader({isFeatured}) {
  return (

    <div className="animate-pulse mr-2 app-rounded shadow-md bg-rand-200">
      <div
        className={`bg-rand-300 ${isFeatured ? 'image-aspect-ratio-hr brand-featured-size app-rounded' : 'brand-normal-size w-20'} `}/>

      {isFeatured &&
      <div className="text-center py-2.5 w-full">
        <div className="h-4 mx-2">&nbsp;</div>
      </div>
      }

    </div>
  );
}

export function BrandError({errorMsg, retry, isFeatured}) {
  return (
    <div
      className={`flex flex-col items-center bg-red-100 ${isFeatured ? 'aspect-ratio-vertical-banner-image brand-featured-size shadow-md' : 'brand-normal-size'} justify-evenly items-center`}>
      <div className="text-center text-xs text-error-500 whitespace-pre-wrap font-bold px-2">{errorMsg}</div>
      <div className="text-center">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>

    </div>
  );
}

export function BrandNoData({msg}) {
  return (
    <div className="w-full flex items-center justify-center bg-secondary-300 h-44 text-rand-400">
      {msg ? msg : 'No Data'}
    </div>
  );
}